<template>
  <Modal v-model="openForm" title="报警明细" footer-hide fullscreen>
    <div>
      <Table
        border
        :columns="columns"
        :data="tableData"
        no-data-text="<div class='table-no-data'></div>"
        :height="utils.setTableHeight(140)"
      >
        <template slot-scope="{ row, index }" slot="address">
          <a :title="row.address" @click="openMap(row)">{{ row.address }}</a>
        </template>
        <template slot-scope="{ row, index }" slot="fujian">
          <Button :disabled="row.fileState == 0" @click="openFujian(row)"
            >查看</Button
          >
        </template>
      </Table>
      <div id="mypage">
        <Button type="primary" @click="exportAll">导出</Button>
        <div>
          <Page
            :current="1"
            :total="total"
            :page-size="searchItem.pageSize"
            :page-size-opts="[10, 50, 100]"
            show-total
            show-elevator
            show-sizer
            @on-change="changePage"
            @on-page-size-change="pageSizeChange"
          ></Page>
        </div>
      </div>
      <ly-map ref="lymap"></ly-map>
      <ascSelectFujian ref="ascSelectFujian"></ascSelectFujian></div
  ></Modal>
</template>
<script>
import ascSelectFujian from "./ascSelectFujian.vue";
export default {
  components: { ascSelectFujian },
  data() {
    return {
      openForm: false,
      columns: [
        {
          type: "index",
          width: 70,
          align: "center",
        },
        {
          title: "车牌号",
          key: "carNo",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "设备号",
          key: "deviceNo",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "驾驶员",
          key: "driverName",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "报警名称",
          key: "alarmTypeName",
          minWidth: 200,
          maxWidth: 300,
        },
        {
          title: "单位名称",
          key: "groupName",
          minWidth: 200,
          maxWidth: 300,
        },
        {
          title: "事件描述",
          key: "evetDesc",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "报警等级",
          key: "level",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "发动机",
          key: "accStatus",
          render: (h, data) => {
            return h("div", this.$t("accStatus." + data.row.accStatus));
          },
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "速度",
          key: "speed",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "报警地点",
          slot: "address",
          minWidth: 200,
          maxWidth: 300,
        },
        {
          title: "报警时间",
          key: "alarmTime",
          render: (h, data) => {
            return h("div", this.utils.time(data.row.alarmTime));
          },
          minWidth: 130,
          maxWidth: 200,
        },
        {
          title: "附件",
          slot: "fujian",
          width: 70,
          fixed: "right",
        },
      ],
      tableData: [],
      total: 0,
      searchItem: {
        deviceId: 0,
        endTime: 0,
        evetType: "",
        startTime: 0,
        pageSize: 50,
        pageNumber: 1,
      },
    };
  },
  methods: {
    open(v) {
      this.openForm = true;
      this.searchItem.startTime = v.startTime;
      this.searchItem.endTime = v.endTime;
      this.searchItem.deviceId = v.deviceId;
      this.searchItem.evetType = v.evetType;
      this.getList();
    },
    getList() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.alarm + "/alarmAsc/item",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        if (res) {
          this.total = res.data.data.total;
          var data = res.data.data.dataList;
          console.log(data);
          this.tableData = data;
        }
      });
    },
    exportAll() {
      var params = [
        {
          name: "deviceId",
          value: this.searchItem.deviceId,
        },
        {
          name: "evetType",
          value: this.searchItem.evetType,
        },
        {
          name: "startTime",
          value: this.searchItem.startTime,
        },
        {
          name: "endTime",
          value: this.searchItem.endTime,
        },
      ];
      this.utils.exportData(this.axios.ipPort + "/cloud-common-server-alarm/alarmAsc/export/item", params);
    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    openMap(v) {
      var obj = {
        address: v.address,
        lng: v.x,
        lat: v.y,
      };
      this.$refs.lymap.open(obj);
    },
    openFujian(v) {
      this.$refs.ascSelectFujian.open(v);
    },
  },
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// ../common/src/components/alarm/ascSelectDetail.vue